<template>
  <v-row class="content-header align-md-center flex-md-row" no-gutters>
    <component :is="headerWrapper" :to="to" class="content-header__title flex-shrink-1">
      <v-row class="align-center flex-nowrap" no-gutters style="min-width: 0;">
        <div class="mr-2 d-flex align-center flex-shrink-0" v-if="this.$slots.icon">
          <slot name="icon"/>
        </div>
        <div class="d-flex flex-column" style="min-width: 0;">
          <div :class="headingClassNames">
            <div
              :class="titleClassNames"
              style="min-width: 0;"
              data-testid="content-title"
            >
              <template v-if="!!title">{{ title }}</template>
              <template v-else-if="$slots.title"><slot name="title" /></template>
            </div>
            <template v-if="!!subtitle && typeof subtitle === 'string'">
              <div :class="subtitleClassNames" data-testid="content-subtitle">{{ subtitle }}</div>
            </template>
            <template v-else-if="$slots.subtitle">
              <div :class="subtitleClassNames">
                <slot name="subtitle" />
              </div>
            </template>
          </div>
          <div
            class="content-header__description caption my-1 hidden-sm-and-down"
            v-if="description"
            data-testid="content-description"
          >{{ description }}</div>
        </div>
        <counter class="hidden-md-and-up ml-auto" :count="count" v-if="hasCount" />
      </v-row>
    </component>
    <slot />
    <counter class="hidden-sm-and-down ml-auto" :count="count" v-if="hasCount" />
  </v-row>
</template>

<script>
import Counter from './Counter';
import ButtonWrapper from './ButtonWrapper';
import DefaultWrapper from './DefaultWrapper';

export default {
  name: 'content-header',
  components: {
    Counter,
    ButtonWrapper,
    DefaultWrapper,
  },
  computed: {
    hasCount() {
      return this.count != null;
    },
    headerWrapper() {
      return this.to ? ButtonWrapper : DefaultWrapper;
    },
    headingClassNames() {
      return [
        'content-header__heading',
        'd-flex',
        'align-center',
        {
          'content-header__heading--stack-mobile': this.stackHeadingOnMobile,
        },
      ];
    },
    titleClassNames() {
      return [
        'content-header__title-text',
        'primary--text',
        'text-truncate',
        'overflow-hidden',
        this.titleClass,
        {
          'content-header__title-text--stack-mobile': this.stackHeadingOnMobile,
        },
      ];
    },
    subtitleClassNames() {
      return [
        'content-header__subtitle',
        'flex-shrink-0',
        this.subtitleClass,
        {
          'content-header__subtitle--stack-mobile': this.stackHeadingOnMobile,
        },
      ];
    },
  },
  props: {
    count: [Number, String],
    description: String,
    stackHeadingOnMobile: Boolean,
    title: String,
    titleClass: String,
    subtitle: String,
    subtitleClass: String,
    to: String,
  },
};
</script>

<style scoped lang="sass">
@import 'vuetify/src/styles/styles.sass'

.content-header
  &__heading
    min-width: 0

  &__title
    color: inherit !important
    height: auto!important
    margin: -0.5rem!important
    padding: 0.5rem!important
    width: 100%!important

    // Avoid overflow of the sensor name and installation site name
    ::v-deep .v-btn__content
      width: 100%

  &__subtitle
    min-width: 0

@media #{map-get($display-breakpoints, 'sm-and-down')}
  .content-header
    &__heading--stack-mobile
      align-items: flex-start
      flex-direction: column
      gap: 4px

    &__title-text--stack-mobile
      margin-right: 0 !important
      width: 100%

    &__subtitle--stack-mobile
      width: 100%
</style>
